module.exports = __webpack_public_path__ + "img/cross.db46abbd.svg";